const $j = (typeof window !== 'undefined' && (window as Window & { $j: unknown }).$j) || (() => {}) as (s: string) => unknown;

function resolveTabHash(hash: string): string {
    const h = hash.replace(/^#/, '');
    if (h === 'settings' || h === 'notifications-settings') {
        return '#notifications-settings';
    }
    if (h === 'notifications-inbox') {
        return '#notifications-inbox';
    }
    return '';
}

function activateTab(targetHash: string, updateHash: boolean): void {
    const hash = resolveTabHash(targetHash) || '#notifications-inbox';
    const link = document.querySelector(`.tab-nav a[href="${hash}"]`) as HTMLAnchorElement | null;
    if (!link) {
        return;
    }
    ($j('.tab') as { hide: () => void }).hide();
    ($j('.tab-nav') as { find: (s: string) => { removeClass: (c: string) => void } }).find('a.active').removeClass('active');
    ($j(link) as { addClass: (c: string) => void }).addClass('active');
    ($j(hash) as { fadeIn: (n: number) => void }).fadeIn(300);
    if (updateHash && window.location.hash !== hash) {
        history.pushState(null, '', hash);
    }
}

export function tabNav(): void {
    if (!document.querySelector('.tab-nav')) {
        return;
    }
    ($j('.tab-nav li a') as { click: (fn: (e: { preventDefault: () => void }) => boolean) => void }).click(function (
        event: { preventDefault: () => void }
    ) {
        event.preventDefault();
        const el = ($j as (el: unknown) => unknown)(this) as { attr: (a: string) => string };
        activateTab(el.attr('href'), true);
        return false;
    });
    window.addEventListener('hashchange', () => {
        const hash = resolveTabHash(window.location.hash);
        if (hash) {
            activateTab(hash, false);
        }
    });
    window.addEventListener('popstate', () => {
        const hash = resolveTabHash(window.location.hash) || '#notifications-inbox';
        activateTab(hash, false);
    });
    const initial = resolveTabHash(window.location.hash);
    if (initial) {
        activateTab(initial, false);
    } else {
        setTimeout(() => {
            ($j('.tab-nav li a.active') as { click: () => void }).click();
        }, 0);
    }
}
